import React from 'react';
import AllWorkListTable from './allWorkListTable';

const AllWorkList = () => {
  return (
<AllWorkListTable type="all"/>
  )
}
export default AllWorkList;